import { PageHead } from '@/components'
import styled, { ThemeProvider } from 'styled-components'
import CasePreview, {
  dataPreviewGlobalKey,
  getThemePreviewGlobalKey,
} from '@/components/cases/CasePreview'
import CaseOverview, {
  dataOverviewGlobalKey,
  getThemeOverviewGlobalKey,
} from '@/components/cases/CaseOverview'
import CaseFeatures, {
  StyledCaseFeatures,
  dataFeaturesGlobalKey,
  getThemeFeaturesGlobalKey,
} from '@/components/cases/CaseFeatures'

import { paletteGlobalKey } from '@/assets/styles/vars'
import CaseGetInTouch, {
  getThemeGitGlobalKey,
  getThemeGitGlobalKeyTwo,
} from '@/components/cases/CaseGetInTouch'
import CaseMoreWorks, { getThemeMoreWorksGlobalKey } from '@/components/cases/CaseMoreWorks'
import CaseWorkflow, {
  dataWorkflowGlobalKey,
  getThemeWorkflowGlobalkey,
} from '@/components/cases/CaseWorkflow'
import CaseTriple, {
  dataTripleGlobalKey,
  getThemeTripleGlobalKey,
} from '@/components/cases/CaseTriple'
import CaseFeaturesSlider, {
  getThemeFeaturesSliderGlobalKey,
} from '@/components/cases/CaseFeaturesSlider'
import vars from '@/assets/styles/vars'

const headline =
  'Case Study: New Website & Personal Accounts for GlobalKey, Electronic Component Trading'
const description =
  "Experience the journey of a growing company's shift from outdated processes to a cutting-edge online platform, catalyzing efficiency and personalized B2B interactions."

const GlobalKey = ({ metricsData }) => {
  const data = metricsData.createCase({
    headline: headline,
    alternativeHeadline: description,
    datePublished: '2023-08-22',
    about: dataPreviewGlobalKey.tags.map(({ title }) => title),
  })

  return (
    <StyledCaseGlobalKey>
      <PageHead
        title="Developing a platform for a company that imports and distributes electronic components | dev.family"
        description={description}
        ogImage={require('@/assets/images/global-key/og-global.png').default.src}
        twImage={require('@/assets/images/global-key/tw-global.png').default.src}
        metricsData={data}
        themeColor={paletteGlobalKey.darkBlue}
      />

      <ThemeProvider
        theme={getThemePreviewGlobalKey({
          palette: paletteGlobalKey,
          PreviewImageBg: require('@/assets/images/global-key/global-key-preview-bg.svg?url')
            .default,
          PreviewImageBgTablet: require('@/assets/images/global-key/global-key-preview-bg.svg?url')
            .default,
          PreviewImageBgMobile: require('@/assets/images/global-key/global-key-preview-bg.svg?url')
            .default,
          PreviewImage: require('@/assets/images/global-key/global-key-preview-img.png'),
        })}
      >
        <CasePreview
          tags={dataPreviewGlobalKey.tags}
          title={dataPreviewGlobalKey.title}
          titleExtended={dataPreviewGlobalKey.titleExtended}
          description={dataPreviewGlobalKey.description}
        />
      </ThemeProvider>

      <ThemeProvider theme={getThemeOverviewGlobalKey({ palette: paletteGlobalKey })}>
        <CaseOverview data={dataOverviewGlobalKey} />
      </ThemeProvider>

      <ThemeProvider theme={getThemeWorkflowGlobalkey({ palette: paletteGlobalKey })}>
        <CaseWorkflow data={dataWorkflowGlobalKey} />
      </ThemeProvider>

      <ThemeProvider
        theme={getThemeGitGlobalKey({
          palette: paletteGlobalKey,
        })}
      >
        <CaseGetInTouch title="💫 Have a similar project?" />
      </ThemeProvider>

      <StyledCaseGlobalKeyFeaturesWrap>
        <ThemeProvider theme={getThemeFeaturesSliderGlobalKey({ palette: paletteGlobalKey })}>
          <CaseFeaturesSlider />
        </ThemeProvider>
      </StyledCaseGlobalKeyFeaturesWrap>

      <ThemeProvider
        theme={getThemeTripleGlobalKey({
          palette: paletteGlobalKey,
        })}
      >
        <CaseTriple data={dataTripleGlobalKey} />
      </ThemeProvider>

      <ThemeProvider theme={getThemeFeaturesGlobalKey({ palette: paletteGlobalKey })}>
        <CaseFeatures data={dataFeaturesGlobalKey} />
      </ThemeProvider>

      <ThemeProvider
        theme={getThemeGitGlobalKeyTwo({
          palette: paletteGlobalKey,
        })}
      >
        <CaseGetInTouch title="⚡ Have the same project? ⚡" />
      </ThemeProvider>

      <ThemeProvider theme={getThemeMoreWorksGlobalKey({ palette: paletteGlobalKey })}>
        <CaseMoreWorks showCasesById={[7, 2, 3]} />
      </ThemeProvider>
    </StyledCaseGlobalKey>
  )
}

GlobalKey.options = {
  header: { theme: 'dark', companionColor: paletteGlobalKey.darkBlue },
  footer: { $mod: 'bushe' },
}

export default GlobalKey

const StyledCaseGlobalKey = styled.div`
  background-color: ${paletteGlobalKey.white};

  ${StyledCaseFeatures} {
    padding-top: 0;
  }
`

const StyledCaseGlobalKeyFeaturesWrap = styled.section`
  padding-top: 64px;
  background-color: ${paletteGlobalKey.darkBlue};

  @media (max-width: ${`${vars.breakpoints.lMobile}px`}) {
    padding-top: 30px;
  }
`
